export function constructParams(academicLevel, schools, pageRetour) {
  const brochureParams = pageRetour.filter(el => el.academics.includes(academicLevel) && el.schools.some(school => schools.includes(school))).map(el => '&brochure[]=' + el.param)
  return brochureParams.join('')
}
